import mapboxgl from "mapbox-gl";
import React, {useEffect, useRef, useState} from "react";
import ReactDOM from "react-dom";
import "./Map.css";
import CircleMarker from "./CircleMarker";
import greenCourt from "./resources/green.svg";
import redCourt from "./resources/red.svg";
import grayCourt from "./resources/gray.svg";

mapboxgl.accessToken =
    "pk.eyJ1IjoiYWRhbWtjb29rOTkiLCJhIjoiY2xmbW9nNWZyMGRzMzQxcDlrb3I3OTN5dyJ9.T-0B8HJnVDI29UBeZQ0Kaw";

const Marker = ({ onClick, data, recentlyUpdated }) => {
  const _onClick = () => {
    onClick(data);
  };

  //console.log('data in marker', data);

  const players = data.players;
  const peoplePerCourt = players / data.properties.courts;
  const courts = data.properties.courts;

  let percent = (players / (courts * 4))*100;

  if (recentlyUpdated){
    return (
        <button onClick={_onClick}>
          <CircleMarker percent={percent} />
        </button>

    );
  } else {
    return (
        <button onClick={_onClick}>
          <CircleMarker percent={'?'} />
        </button>

    );
  }


};



const Map = (props) => {
  const mapContainerRef = useRef(null);
  const [locations, setLocations] = useState(null);
  let setLoading = props.setLoading;
  let data = props.data;

  function getData(){
    console.log("in map getdata")

    fetch('https://us-central1-aircourt-d62eb.cloudfunctions.net/widgets/all', {
      method: 'GET',
    })
        .then((response) => response.json())
        .then((data) => {
          //console.log('Success:', data);

          setLocations(data)
          setLoading(false)

        })
        .catch((error) => {
          console.error('Error:', error);
        });
  }


  // Initialize map when component mounts
  useEffect(() => {
    if (locations) {
      const map = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: "mapbox://styles/mapbox/streets-v11",
        center: [-111.801, 40.370],
        zoom: 10.77,
        iconSize: ['interpolate', ['linear'], ['zoom'], 10, 1, 15, 0.5]
      });


      /*
      let coordinates;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          coordinates = [position.coords.latitude, position.coords.longitude];
        });
      }


      map.on('load', function () {
        map.flyT{
          center: [
            -74.5 + (Math.random() - 0.5) * 10, // Example data
            40 + (Math.random() - 0.5) * 10 // Example data
          ],
          essential: true // this animation is considered essential with respect to prefers-reduced-motion
        });
      })

      */
//list of courts and their data
let courts = Object.keys(locations)
let courtData = Object.values(locations)


// Render custom marker components
for (let i = 0; i < courts.length; i++) {

  //get all data
  const thisCourt = courtData[i]

  //calculate open courts
  let players = thisCourt.players;
  const numCourts = thisCourt.properties.courts;
  let percent = Math.trunc((players / (numCourts * 4)) * 100)
  let filledCourts = Math.ceil(players / 4);
  let openCourts = thisCourt.properties.courts - filledCourts;
  if (openCourts < 0) {
    openCourts = 0;
  }


  //update last time and sensor name
  let lastUpdated = thisCourt.timeUpdated;
  let sensorName = thisCourt.sensorName;
  let battery = thisCourt.batteryPercent;
  let address = thisCourt.properties.address;
  let picture = thisCourt.properties.picture;
  if (picture === undefined) {
    picture = 'https://aircourt-d62eb.web.app/static/media/ac.771cd8e8.png' //aircourt logo
  }
  let updatedFullString = "";
  let recent;
  if (lastUpdated === undefined || sensorName === undefined) {
    updatedFullString = "No active sensor here!"
    recent = false
  } else {
    updatedFullString = "Updated " + lastUpdated //+", Sensor: " + sensorName + ", " +  battery + "%, " + players + "p";
    recent = true;
  }

  const courtSymbols = [];
  //make number of courts
  for (let i = 0; i < numCourts; i++) {
    if (i < openCourts) {
      if (recent) {
        courtSymbols.push(`<img src=${greenCourt} alt="pickle" height="60" width="50"/>`)
      } else {
        courtSymbols.push(`<img src=${grayCourt}  alt="pickle" height="60" width="50"/>`)
      }
    }
    if (i >= openCourts) {
      if (recent) {
        courtSymbols.push(`<img src=${redCourt} alt="pickle" height="60" width="50"/>`)
      } else {
        courtSymbols.push(`<img src=${grayCourt} alt="pickle" height="60" width="50"/>`)
      }
    }
  }

  // Render a Marker Component on our new DOM node
  const ref = React.createRef();
  ref.current = document.createElement("div");
  ReactDOM.render(
      <Marker onClick={markerClicked} data={thisCourt} recentlyUpdated={recent}/>,
      ref.current
  );

  if (recent) {
    // Create a Mapbox Marker at our new DOM node
    new mapboxgl.Marker(ref.current)
        .setLngLat(thisCourt.geometry.coordinates)
        .setPopup(
            new mapboxgl.Popup({offset: 40, width: 40, className: "apple-popup"}) // add popups
                .setHTML(
                    `<div class=full id="full">
          <img class=image src=${picture} />
          <div class=box>
          <h5 class=header>${thisCourt.properties.title}</h5>
          <p class=address id="address1" >${thisCourt.properties.address}</p>
          <p class=address >Open ${thisCourt.properties.hours}</p>
          <p class=text >${updatedFullString}</p> 
          <table class=courtsNums>
            <tr>
              <th class=courtsAvialable>${openCourts}/${numCourts}</th>
              <th class=courtsAvialableText>Courts Currently <br> Available</th>
            </tr>
          </table>
          <div class=court>
          ${courtSymbols}
          </div>
          <div class=buttonPadding >
          <button class=button onClick={navigator.clipboard.writeText(document.getElementById("address1").innerText);}>Copy Address</button>
          </div>
          </div>
        </div>`))
        .addTo(map);
  } else {
    new mapboxgl.Marker(ref.current)
        .setLngLat(thisCourt.geometry.coordinates)
        .setPopup(
            new mapboxgl.Popup({offset: 40, width: 40, className: "apple-popup"}) // add popups
                .setHTML(
                    `<div class=full>
          <img class=noImage src=${picture} />
          <div class=box>
          <h5 class=header>${thisCourt.properties.title}</h5>
          <p class=address id="address2" >${thisCourt.properties.address}</p>
          <p class=address>Open ${thisCourt.properties.hours}</p>
          <p class=text >${updatedFullString}</p> 
          <div class=court>
          ${courtSymbols}
          </div>
          <div class=buttonPadding >
          <button class=button onClick={navigator.clipboard.writeText(document.getElementById("address2").innerText);}>Copy Address</button>
          </div>
          </div>
        </div>`))
        .addTo(map);
  }

}

// Add navigation control (the +/- zoom buttons)
map.addControl(new mapboxgl.NavigationControl(), "bottom-right");

// Add geolocate control to the map.
map.addControl(
    new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      // When active the map will receive updates to the device's location as it changes.
      trackUserLocation: true,
      // Draw an arrow next to the location dot to indicate which direction the device is heading.
      showUserHeading: true
    }), "bottom-right"
);

// Center the map on the coordinates of any clicked circle from the 'circle' layer.
map.on('click', 'circle', (e) => {
  map.flyTo({
    center: e.features[0].geometry.coordinates
  });
});

// Clean up on unmount
return () => map.remove();
}


}, [locations]);


useEffect(() => {
getData()
}, []);


const markerClicked = (feature) => {
//something
};

return <div className="map-container" ref={mapContainerRef} />;
};

export default Map;